import auth from './auth';
import user from './user';
import articles from './articles';
import anthologies from './anthologies';
import topics from './topics';
import statistics from './statistics';

const actions = {
	auth,
	user,
	articles,
	anthologies,
	topics,
	statistics,
};

export default actions;
